import LandingPage, { type LandingPageContent } from '../LandingPage';

const content: LandingPageContent = {
  eyebrow: 'Private Home Sale During Divorce',
  headline: 'You Can Love Your Home and Still Need to Leave It.',
  subhead:
    'Selling during a divorce is one of the hardest transitions a homeowner faces. You deserve a process that protects your equity, your privacy, and your peace of mind.',
  truth:
    'Nobody talks about what it actually feels like to sell the house during a divorce.\nThe memories. The shared walls. The negotiations on top of negotiations.\n\nYou\'re not just selling a property — you\'re untangling a life. And the last thing you need is an agent who treats this like just another listing.\n\nThis is different. And you need someone who gets that.',
  clarityPoints: [
    'Private sale options that keep your home off MLS — no public exposure, no neighbor gossip.',
    'Cash offers available in as few as 10 days when timing is critical.',
    'Neutral, data-backed valuations both parties can trust.',
    'Strategic renovation funding with no out-of-pocket costs — maximize equity without the conflict.',
    'A dedicated process built for two-party situations, coordinated with your attorneys.',
  ],
  calm:
    'You don\'t have to figure this out alone.\nAnd you don\'t have to sacrifice your equity for speed.\n\nThere\'s a path through this that protects what you\'ve built — and gives you room to breathe.',
  ctaText: 'See My Private Options',
  pullQuote: 'Selling can be calm. Selling can be private. Selling can preserve dignity.',
  utmSource: 'sell-divorce',
};

export default function SellDivorcePage() {
  return <LandingPage content={content} />;
}
